import { render, staticRenderFns } from "./MainNavBar.component.vue?vue&type=template&id=1518245c&scoped=true&lang=pug"
import script from "./MainNavBar.component.vue?vue&type=script&lang=ts"
export * from "./MainNavBar.component.vue?vue&type=script&lang=ts"
import style0 from "./MainNavBar.component.vue?vue&type=style&index=0&id=1518245c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1518245c",
  null
  
)

export default component.exports